import { locationIndexOptions, locationStoreMutation } from '$api'
import { CreateLocationForm, CreateLocationSchema } from '$features/settings/forms/location/create'
import { SettingsRoutePath } from '$features/settings/routes/protected'
import { Router } from '$utils/router'
import { NavigableModal } from '$components'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { ToastHelper } from '$components'
import { ToastType } from '$components'

export function CreateLocationModal() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const handleClose = () => navigate(Router.buildRoute(SettingsRoutePath.Settings, SettingsRoutePath.SettingsGeneral))

  const locationMutation = useMutation({
    ...locationStoreMutation(),
    onSuccess: () => {
      ToastHelper.createSuccess(ToastType.Location)
      queryClient.invalidateQueries({ queryKey: locationIndexOptions().queryKey })
      handleClose()
    },
    onError: () => ToastHelper.createError(ToastType.Location),
  })

  const handleSubmit = (values: CreateLocationSchema) => {
    locationMutation.mutate({
      body: {
        name: values.name,
        address: {
          line_one: values.address.line_one,
          line_two: values.address.line_two,
          city: values.address.city,
          post_code: values.address.post_code,
          country: values.address.country,
        },
        business_hours: values.business_hours,
      },
    })
  }

  return (
    <CreateLocationForm
      isLoading={locationMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={handleClose}
    >
      <NavigableModal onClose={handleClose}>
        <NavigableModal.Header>
          <NavigableModal.Heading>
            Create Location
          </NavigableModal.Heading>
        </NavigableModal.Header>

        <NavigableModal.Content>
          <CreateLocationForm.Content />
        </NavigableModal.Content>

        <NavigableModal.Footer>
          <CreateLocationForm.Controls />
        </NavigableModal.Footer>
      </NavigableModal>
    </CreateLocationForm>
  )
}
